import { jsx as _jsx } from "react/jsx-runtime";
import { FONT_WEIGHT_NORMAL } from "../../../constants/fontWeight.consts.js";
import Button from "../../../components/atoms/Button/index.js";
import Icon from "../../../components/atoms/Icon/index.js";
export const LogoutButtonAtomComponent = ({ children, ...props }) => (_jsx(Button, { "data-testid": "LogoutButton", variant: "text", startIcon: _jsx(Icon, { "data-testid": "LogoutButtonIcon", type: "arrow-right-from-bracket" }), sx: { fontWeight: FONT_WEIGHT_NORMAL }, ...props, children: children }));
export default LogoutButtonAtomComponent;
